import React from "react";
import { FileSearch, UploadCloud } from "lucide-react";

export default function EmptyState({ filtersActive, onClearFilters }) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-4 bg-white border border-[#E5E7EB] rounded-xl">
      <div className="w-14 h-14 rounded-full bg-[#FEF2F2] flex items-center justify-center mb-4">
        {filtersActive ? (
          <FileSearch className="w-7 h-7 text-[#DC2626]" />
        ) : (
          <UploadCloud className="w-7 h-7 text-[#DC2626]" />
        )}
      </div>
      {filtersActive ? (
        <>
          <p className="text-[#1F2937] font-medium">
            No ECG cases match the selected filters.
          </p>
          <p className="text-sm text-[#6B7280] mt-1">
            Try adjusting or clearing your filters.
          </p>
          <button
            onClick={onClearFilters}
            className="mt-4 px-4 py-2 text-sm font-medium rounded-lg bg-[#DC2626] text-white hover:bg-[#B91C1C] transition-colors"
          >
            Clear Filters
          </button>
        </>
      ) : (
        <>
          <p className="text-[#1F2937] font-medium">No ECG cases found.</p>
          <p className="text-sm text-[#6B7280] mt-1">
            Try clearing your filters or upload a new ECG case.
          </p>
        </>
      )}
    </div>
  );
}
